// extracted by mini-css-extract-plugin
module.exports = {"joinPc":"JoinMethods_joinPc__2aW7c"};